<template>
    <div>
        <e-dialog
                dialogTitle="易派客提醒您"
                :centerDialogVisible="costCoverageVisible"
                @resetPopupData="resetPopupData"
                @submitPopupData="submitPopupData"
                :popupWidth="'420px'">
            <div>该产品只收取高等级费用（1级为最高等级），请问是否自动覆盖？</div>
        </e-dialog>
    </div>
</template>

<script>
    import eDialog from "@/modules/projectA/components/common/e-dialog.vue";
    export default {
        name: "costCoverageDialog",
        components:{eDialog},
        props:{
            costCoverageVisible:Boolean,
        },
        data() {
            return {}
        },
        methods:{
            resetPopupData(){
                this.$emit('closeDialog');
            },
            submitPopupData(){
                this.$emit('mergerExpenses');
            },
        },
    }
</script>

<style scoped lang="scss">

</style>